import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import './index.css';


export default class SearchBar extends React.Component {
  static propTypes = {
    placeholder: propTypes.string,
    value: propTypes.string,
    showCancel: propTypes.bool,
    onBlur: propTypes.func,
    onFocus: propTypes.func,
    onClear: propTypes.func,
    onCancel: propTypes.func,
    onChange: propTypes.func,
    onSubmit: propTypes.func
  };

  static defaultProps = {
    placeholder: 'Search',
    value: '',
    showCancel: true,
  };

  // 输入框 dom节点
  input = null;

  focus() {
    this.input.focus();
  }

  blur() {
    this.input.blur();
  }

  onSubmit = (e) => {
    e.preventDefault();
    let {onSubmit} = this.props;
    onSubmit && onSubmit(e);
  };

  onBlur = (e) => {
    let {onBlur} = this.props;
    onBlur && onBlur(e);
  };

  onFocus = (e) => {
    let {onFocus} = this.props;
    onFocus && onFocus(e);
  };

  onClear = (e) => {
    let {onClear} = this.props;
    onClear && onClear(e);
  };

  onCancel = (e) => {
    let {onCancel} = this.props;
    onCancel && onCancel(e);
  };

  render() {
    let {
      placeholder,
      value,
      className,
      onSubmit,
      showCancel,
      ...rest
    } = this.props;
    delete rest.onCancel;
    delete rest.onClear;

    className = classNames('component-search-bar', className, {
      'component-search-bar-active': true // 不能隐藏“取消按钮”，所有永远active状态
    });

    // clear按钮样式
    let clearClassName = classNames('clear', {
      'clear-show': value
    });

    return (
      <form {...rest} className={className} onSubmit={this.onSubmit}>
        <div className='body'>
          <input
            ref={(dom) => {
              this.input = dom;
            }}
            type='search'
            value={value}
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            maxLength='30' />

          <div className='placeholder'>
            <i className='icon icon-search' />
            <span>{value ? '' : placeholder}</span>
          </div>

          <div className={clearClassName} onClick={this.onClear}>
            <i className='icon icon-clear' />
          </div>
        </div>
        {
          showCancel ?
            <div className='footer' onClick={this.onCancel}>
              <button type='button'>取消</button>
            </div> : false
        }
      </form>
    );
  }
}


NotFound.propTypes = {
  desc: propTypes.string
};

const pic = require('./no-list.png');

export function NotFound(props) {

  return (
    <div className='component-search-bar-not-found'>
      <img src={pic} alt='NotFound' />
      <p>{props.desc}</p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/SearchBar/index.js